import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "../firebase";
import { getAuthErrorMessage } from "../utils/authErrors";

const AddAdmin = () => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("admin");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleAddAdmin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      // 1. Add to Firestore
      await addDoc(collection(db, "admins"), {
        email,
        role,
        createdAt: new Date(),
        status: "pending",
      });

      // 2. Send Firebase Auth Invite Email Link
      const actionCodeSettings = {
        url:
          `https://course-admin-web.vercel.app/admin-complete-signup?email=` +
          email, // <--- Must match!
        handleCodeInApp: true,
      };
      // Send email link:
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);

      setSuccess(
        "Admin invited! They’ll receive an email to set their password and complete registration."
      );
      setEmail("");
      setRole("admin");
    } catch (err) {
      setError(getAuthErrorMessage(err, "inviteAdmin"));
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white rounded-xl shadow-xl p-8">
      <h2 className="text-2xl font-bold mb-4 text-blue-700">Add Admin</h2>
      <form onSubmit={handleAddAdmin} className="space-y-4">
        <div>
          <label className="block mb-1 font-semibold">Email</label>
          <input
            className="w-full px-4 py-2 border rounded-lg"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold">Role</label>
          <select
            className="w-full px-4 py-2 border rounded-lg"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="admin">Admin</option>
            <option value="superadmin">Super Admin</option>
            {/* Add more roles here */}
          </select>
        </div>
        <button
          className="w-full py-2 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700"
          type="submit"
        >
          Add Admin
        </button>
        {success && <div className="text-green-600 mt-2">{success}</div>}
        {error && <div className="text-red-500 mt-2">{error}</div>}
      </form>
    </div>
  );
};

export default AddAdmin;
